export enum VerticalMenuIds {
    Container = 'vertical-menu/container',
    HideMenu = 'vertical-menu/hide-menu',
    ClientPicker = 'vertical-menu/client-picker',
    ClientPickerClosed = 'vertical-menu/client-picker/closed',
    ClientPickerOpened = 'vertical-menu/client-picker/opened',
}
